import { call, put, race, select, take } from 'redux-saga/effects';
import { serviceUnavailable } from '../../../modules/app/actions';
import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../../modules/app/errors';
import { restartUserJourney } from '../../../modules/auth/saga';
import { close, open } from '../../../modules/modal/actions';
import * as form from '../../FormMessage/actions';
import * as notify from '../../layout/Notifications/actions';
import { getCardNumber } from '../../../modules/account/selectors';
import {
  CANCEL_CARD_ATTEMPT,
  CANCEL_CARD_CONFIRM,
  CANCEL_CARD_REJECT,
  cancelCardFailure,
  cancelCardSuccess
} from './actions';
import { postLostCard } from './rest';

/* eslint-disable no-constant-condition */
function* cancelCard() {
  try {
    yield put(open({ componentName: 'RequestInProgress' }));
    const cardNumber = yield select(getCardNumber);
    yield call(postLostCard, cardNumber);
    yield put(cancelCardSuccess());
    yield put(open({ componentName: 'CardCanceled' }));
  } catch (e) {
    yield put(cancelCardFailure(e));
    yield put(close());
    if (e instanceof UnauthorizedAccessError) {
      yield call(restartUserJourney);
    } else if (e instanceof ConnectionError) {
      yield put(notify.add('Connection error.', notify.ERROR));
    } else if (e instanceof ServiceUnavailableError) {
      yield put(serviceUnavailable());
    } else {
      throw e;
    }
  }
}

export default function* watchCancelCardAttempt() {
  while (yield take(CANCEL_CARD_ATTEMPT)) {
    yield put(form.clearMessage());
    yield put(open({ componentName: 'CancelCard' }));

    const { confirm } = yield race({
      confirm: take(CANCEL_CARD_CONFIRM),
      reject: take(CANCEL_CARD_REJECT)
    });

    if (confirm) {
      yield call(cancelCard);
    } else {
      yield put(close());
    }
  }
}
/* eslint-enable no-constant-condition */
